export default "__VITE_ASSET__be2b792c__"